import { render, staticRenderFns } from "./EmailSmsLogListView.vue?vue&type=template&id=63d2508a&scoped=true"
import script from "./EmailSmsLogListView.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogListView.vue?vue&type=script&lang=js"
import style0 from "./EmailSmsLogListView.vue?vue&type=style&index=0&id=63d2508a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d2508a",
  null
  
)

export default component.exports